import { useCallback, useEffect, useState } from 'react';
export const useCategoryInteraction = () => {
    const [interactionState, setInteractionState] = useState(null);
    const [isFocused, setIsFocused] = useState(false);
    const [isTextInputFocused, setIsTextInputFocused] = useState(false);
    const resetInteraction = useCallback(() => {
        setInteractionState(null);
        setIsFocused(false);
        setIsTextInputFocused(false);
    }, []);
    useEffect(() => {
        setIsFocused(!!interactionState);
    }, [interactionState]);
    return {
        interactionState,
        setInteractionState,
        isFocused,
        isTextInputFocused,
        setIsTextInputFocused,
        resetInteraction,
    };
};
